import { styled, Typography } from "@mui/material";
const Container = styled("div")(() => ({
  display: "flex",
  flexDirection: "row"
}));
const IconWrapper = styled("div")(({ theme }) => ({
  color: theme.palette.primary[300],
  marginRight: theme.spacing(2),
  marginTop: 3
}));
const Text = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[800],
  ...theme.typography["Sarabun Body 2"]
}));
export {
  Container,
  IconWrapper,
  Text
};
